import { useState, useEffect } from 'react'
import type { Dispatch } from 'react'
import { FieldValues, UseFormMethods } from 'react-hook-form'

const useFormSubmitLoader = <T extends FieldValues>(
  methods: UseFormMethods<T>,
): [boolean, Dispatch<boolean>] => {
  const [loading, setLoading] = useState<boolean>(false)
  useEffect(() => {
    if (methods.formState.isSubmitting) {
      setLoading(true)
    }

    if (!methods.formState.isSubmitting && loading) {
      setLoading(false)
    }
  }, [methods.formState])

  return [loading, setLoading]
}

export default useFormSubmitLoader
